import { Table as MUITable } from '@mui/material';

import styles from './Table.module.scss';

const TableHead = ({ children }: { children: React.ReactNode }) => {
  return <MUITable classes={{ root: styles.table }}>{children}</MUITable>;
};

export default TableHead;
